export default "__VITE_ASSET__CpLwyaND__"